import { memo } from 'react';

import { CopyContent, Typography } from '@/ui';

import type { Props } from './types';

const IdentifierRow = ({ label, value, sensitive = false }: Props) => (
  <>
    <Typography as="dt" muted>
      {label}
    </Typography>
    <dd
      className={`${sensitive ? 'mp-sensitive ' : ''}min-w-0 text-uniform-gray-900 dark:text-uniform-gray-100`}>
      <CopyContent
        content={value}
        className="flex min-w-0 justify-between font-mono text-sm [&>span:first-child]:truncate"
      />
    </dd>
  </>
);

export default memo(IdentifierRow);
